import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Story {
  id: string;
  name: string;
  image: string;
  category: string;
  location: string;
  date: string;
  story: string;
  impact: string;
  language: string;
}

interface SuccessStoriesProps {
  stories: Story[];
}

const SuccessStories: React.FC<SuccessStoriesProps> = ({ stories }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {stories.map((story) => (
        <div
          key={story.id}
          className="bg-card rounded-lg shadow-subtle hover:shadow-elevated transition-all duration-300 overflow-hidden"
        >
          <div className="grid md:grid-cols-5 gap-6 p-6">
            <div className="md:col-span-2">
              <div className="relative md:aspect-[3/4] rounded-lg overflow-hidden">
                <AppImage
                  src={story.image}
                  alt={story.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-semibold">
                  {story.category}
                </div>
              </div>
            </div>
            
            <div className="md:col-span-3 flex flex-col">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-heading font-bold text-foreground">
                  {story.name}
                </h3>
                <span className="bg-accent/10 text-accent px-2 py-1 rounded text-xs font-semibold">
                  {story.language}
                </span>
              </div>
              
              <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-4">
                <span className="flex items-center space-x-1">
                  <Icon name="MapPinIcon" size={14} />
                  <span>{story.location}</span>
                </span>
                <span className="flex items-center space-x-1">
                  <Icon name="CalendarIcon" size={14} />
                  <span>{story.date}</span>
                </span>
              </div>
              
              <div className="flex-1">
                <div className="relative bg-card md:bg-muted/30 md:p-6 md:rounded-2xl md:rounded-tl-none md:shadow-sm md:border md:border-border mb-6">
                  <p className="text-muted-foreground leading-relaxed relative z-10">
                    "{story.story}"
                  </p>
                </div>
                
                <div className="bg-secondary/10 border-l-4 border-secondary rounded-r-lg p-4">
                  <div className="flex items-start space-x-2">
                    <Icon name="SparklesIcon" size={20} className="text-secondary flex-shrink-0 mt-0.5" />
                    <div>
                      <h4 className="font-semibold text-secondary mb-1">Impact</h4>
                      <p className="text-sm text-foreground">{story.impact}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SuccessStories;